export const FETCH_ANNOUNCEMENTS = "FETCH_ANNOUNCEMENTS";
export const POST_ANNOUNCEMENT = "POST_ANNOUNCEMENT";
export const SET_INBOX_ANNOUNCEMENT_SEARCH_PHRASE =
  "SET_INBOX_ANNOUNCEMENT_SEARCH_PHRASE";
export const CLEAR_ANNOUNCEMENTS = "CLEAR_ANNOUNCEMENTS";
